import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'

import { Col, Grid } from 'components/grid'

import { laws } from './data'
import * as S from './styles'

const Legislation: FC = memo(() => (
  <S.Section>
    <Grid col={{ phone: 1, tablet: 1 }}>
      <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
        <S.TitleWrapper>
          <Text as="h2" size="heading2" weight="medium" color="var(--colors-neutral-text-default)">
            Legislação
          </Text>
        </S.TitleWrapper>

        <S.Lead>
          <Text size="heading4" color="var(--colors-neutral-text-default)">
            A CashMe opera de acordo com as leis e regulamentações as quais está sujeita, incluindo-se mas não se
            limitando à:
          </Text>
        </S.Lead>

        <S.Cards>
          {laws.map(({ id, topic, reference, description }) => (
            <S.Card key={id}>
              <Text size="heading5" weight="bold" color="var(--colors-cyan-background-pressed)">
                {topic}
              </Text>

              <Text size="bodySmall" color="var(--colors-neutral-text-contrast-default)">
                <Text as="span" size="bodySmall" color="var(--colors-cyan-background-pressed)">
                  {reference}
                </Text>{' '}
                {description}
              </Text>
            </S.Card>
          ))}
        </S.Cards>
      </Col>
    </Grid>
  </S.Section>
))

Legislation.displayName = 'Legislation'

export default Legislation
